<template>
  <div :class="['inline-flex items-center']" role="group" :aria-disabled="disabled">
    <div class="inline-flex items-center gap-1 bg-white border border-gray-400 rounded-lg">

      <!-- Botones visibles -->
      <template v-for="(btn, index) in visibleButtons" :key="index">
        <template v-if="btn.label">
          <template v-if="showLabel">
            <component :is="iconos[btn.icon]" v-if="!btn.typeIcon" class="shrink-0 size-4" aria-hidden="true"></component>
            <MdiIcon v-else-if="btn.typeIcon == 'mdi'" :icono="btn.icon" class="w-4 h-4" aria-hidden="true" /> {{ btn.label }}
          </template>
          <TooltipDefault
            v-else
            :description="typeof btn.label === 'function' ? btn.label(null) : btn.label">
            <button
              type="button"
              :disabled="disabled"
              :aria-label="getButtonLabel(btn)"
              class="hs-dropdown-toggle rounded-lg p-1.5 inline-flex items-center justify-center bg-white text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 cursor-pointer"
              :class="btn.class"
              @click="btn.click"
            >
              <component :is="iconos[btn.icon]" v-if="!btn.typeIcon" class="shrink-0 size-4" aria-hidden="true"></component>
              <MdiIcon v-else-if="btn.typeIcon == 'mdi'" :icono="btn.icon" class="w-4 h-4" aria-hidden="true" />
            </button>
          </TooltipDefault>
        </template>
        <button
          v-else
          type="button"
          :disabled="disabled"
          :aria-label="getButtonLabel(btn)"
          class="hs-dropdown-toggle rounded-lg p-1.5 inline-flex items-center justify-center bg-white text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 cursor-pointer"
          :class="btn.class"
          @click="btn.click"
        >
          <component :is="iconos[btn.icon]" v-if="!btn.typeIcon" class="shrink-0 size-4" aria-hidden="true"></component>
          <MdiIcon v-else-if="btn.typeIcon == 'mdi'" :icono="btn.icon" class="w-4 h-4" aria-hidden="true" />
        </button>
      </template>

      <!-- Dropdown para botones extra -->
      <div v-if="extraButtons.length" class="hs-dropdown relative inline-flex group">
        <TooltipDefault description="Más opciones">
          <button
            type="button"
            :disabled="disabled"
            aria-label="Más opciones"
            class="hs-dropdown-toggle rounded-md p-1.5 inline-flex items-center justify-center bg-white text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 cursor-pointer"
            aria-haspopup="menu" aria-expanded="false"
          >
            <MdiIcon icono="mdiMenuDown" class="w-4 h-4" aria-hidden="true" />
          </button>
        </TooltipDefault>
        <div
          class="hs-dropdown-menu transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-[10rem] bg-white shadow-md rounded-lg mt-2 z-10"
          role="menu"
        >
          <div class="p-1 space-y-0.5">
            <template v-for="(btn, idx) in extraButtons" :key="idx">
              <button
                :disabled="disabled"
                class="w-full flex items-center gap-x-3.5 py-2 px-3 text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 cursor-pointer"
                @click="btn.click"
              >
                <component :is="iconos[btn.icon]" v-if="!btn.typeIcon" class="shrink-0 size-4" aria-hidden="true"></component>
                <MdiIcon v-else-if="btn.typeIcon == 'mdi'" :icono="btn.icon" class="w-4 h-4" aria-hidden="true" />
                <span>{{ typeof btn.label === 'function' ? btn.label(null) : btn.label }}</span>
              </button>
            </template>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { IButton } from '@/modules/Core/interfaces'
import * as iconos from '@heroicons/vue/24/outline'
import TooltipDefault from '@/modules/Core/components/general/TooltipDefault.vue'
import MdiIcon from '@/modules/Core/components/general/MdiIcon.vue'

const props = defineProps<{
  disabled?: boolean
  showLabel?: boolean
  buttons: IButton<unknown>[]
}>()

const disabled = computed(() => !!props.disabled)
const { showLabel = false } = props

const getButtonLabel = (btn: IButton<unknown>) =>
  typeof btn.label === 'function' ? btn.label(null) : btn.label

const isShown = (btn: IButton<unknown>) => {
  try {
    if (btn == null) return false
    if (typeof btn.show === 'function') return btn.show()
    return Boolean(btn.show)
  } catch(e) {
    console.error('Error en isShown:', e)
    return false
  }
}
const visibleButtons = computed(() => props.buttons.filter(isShown).slice(0, 2))
const extraButtons = computed(() => props.buttons.filter(isShown).slice(2))
</script>
